<template>
    <van-popup :value="value" position="right">
        <van-nav-bar title="选择业务员" left-text="返回" left-arrow @click-left="cancel" :z-index=9999></van-nav-bar>
        <van-search v-model="staffValue" placeholder="按照名称搜索" show-action @search="onSearchStaff"
                    @cancel="onSearchStaff">
            <div slot="action" @click="onSearchStaff">搜索</div>
        </van-search>
        <van-tabs type="line" sticky @click="switchTab">
            <van-tab title="最近">
                <van-list finished-text="没有更多了">
                    <div v-for="staff in staffList" class="card" :key="staff.uuid" @click="assign(staff.uuid)">
                        <table class="layout">
                            <tr>
                                <td class="avatar-box" rowspan="4">
                                    <img :src="avatarUrl + staff.avatar" class="avatar" alt="avatar">
                                </td>
                                <td colspan="2">
                                    <div class="header">
                                        <p class="advisor">{{staff.name}}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" class="content">
                                    <p>
                                        <span class="iconfont icon-call"></span>
                                        <span>{{staff.mobile || '无'}}</span>
                                    </p>
                                    <p>
                                        <span class="iconfont icon-faduanxin"></span>
                                        <span>{{staff.email || '无'}}</span>
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </van-list>
            </van-tab>
            <van-tab title="本部门">
                <van-list finished-text="没有更多了">
                    <div v-for="staff in staffList" class="card" :key="staff.uuid" @click="assign(staff.uuid)">
                        <table class="layout">
                            <tr>
                                <td class="avatar-box" rowspan="4">
                                    <img :src="avatarUrl + staff.avatar" class="avatar" alt="avatar">
                                </td>
                                <td colspan="2">
                                    <div class="header">
                                        <p class="advisor">{{staff.name}}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" class="content">
                                    <p>
                                        <span class="iconfont icon-call"></span>
                                        <span>{{staff.mobile || '无'}}</span>
                                    </p>
                                    <p>
                                        <span class="iconfont icon-faduanxin"></span>
                                        <span>{{staff.email || '无'}}</span>
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </van-list>
            </van-tab>
            <van-tab title="所有">
                <van-list finished-text="没有更多了">
                    <div v-for="(history,index) in deptHistory" :key="history.value" class="history">
                        <a @click="searchHistoryDept(history.value,index)">{{history.text}}</a> <span
                            v-if="index !== deptHistory.length-1">-></span>
                    </div>
                    <template v-if="deptList.length > 0">
                        <div v-for="dept in deptList" :key="dept.uuid" class="deptCard"
                             @click="searchDept(dept.uuid,dept.name)">
                            <div>
                                <p class="dept">
                                    <span class="iconfont icon-bumen content"></span>
                                    <span class="dept">{{dept.name}}</span>
                                </p>
                            </div>
                        </div>
                    </template>

                    <template v-if="staffList.length > 0">
                        <div v-for="staff in staffList" class="card" :key="staff.uuid" @click="assign(staff.uuid)">
                            <table class="layout">
                                <tr>
                                    <td class="avatar-box" rowspan="4">
                                        <img :src="avatarUrl + staff.avatar" class="avatar" alt="avatar">
                                    </td>
                                    <td colspan="2">
                                        <div class="header">
                                            <p class="advisor">{{staff.name}}</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="content">
                                        <p>
                                            <span class="iconfont icon-call"></span>
                                            <span>{{staff.mobile || '无'}}</span>
                                        </p>
                                        <p>
                                            <span class="iconfont icon-faduanxin"></span>
                                            <span>{{staff.email || '无'}}</span>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </template>

                </van-list>
            </van-tab>
        </van-tabs>
    </van-popup>
</template>

<script>
    import {Tab, Tabs, Panel, Button, List, Search, Popup, PullRefresh, NavBar} from 'vant';
    import userService from "../service/userService";
    import {API_URL} from "../common/config";

    export default {
        data: function () {
            return {
                staffList: [],
                staffValue: '',
                loading: false,
                finished: false,
                deptId: '0',
                type: 0,
                type: 0,
                deptList: [],
                deptHistory: []
            }
        },
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [NavBar.name]: NavBar,
            [Popup.name]: Popup
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            callback: {
                type: Function,
                default: null
            }
        },
        computed: {
            avatarUrl() {
                return API_URL + "/oa/common/attachment/showImage?id=";
            }
        },
        created: function () {
			this.onSearchStaff();
        },
        methods: {
            switchTab(index) {
                window.scrollTo(0, 0);
                this.type = index;
                this.onSearchStaff();
            },
            onSearchStaff() {
                this.finished = false;
                this.loading = true;
                this.staffList = [];
                this.deptList = [];
                this.onLoadStaff();
            },
            async onLoadStaff() {
                let resp = await userService.getList(this.type, this.deptId, this.staffValue);
                if (this.type === 2) {
                    if (resp.data.Data.staffList) {
                        this.staffList = resp.data.Data.staffList;
                    }
                    if (resp.data.Data.deptList) {
                        this.deptList = resp.data.Data.deptList;
                    }
                } else {
                    this.staffList = [...this.staffList, ...resp.data.Data];
                }
            },
            searchDept(deptId, name) {
                this.deptId = deptId;
                this.deptHistory.push({"text": name, "value": deptId});
                this.staffList = [];
                this.deptList = [];
                this.onLoadStaff();
            },
            searchHistoryDept(deptId, index) {
                this.deptId = deptId;
                this.deptHistory.splice(index + 1, this.deptHistory.length - index - 1);
                this.staffList = [];
                this.deptList = [];
                this.onLoadStaff();
            },
            assign(value) {
                this.callback(value);
                this.$emit('change', false);
                this.$emit('input', false);
            },
            cancel() {
                this.$emit('change', false);
                this.$emit('input', false);
            }
        }
    }

</script>

<style scoped>
    .history {
        display: inline-block;
        font-size: 0.8rem;
        margin-top: 0.4rem;
        margin-left: 0.6rem;
    }

    .deptCard {
        background-color: white;
        border-radius: 0.15rem;
        margin-left: 0.6rem;
        margin-right: 0.6rem;
        padding: 0.06rem;
        margin-top: 0.6rem;
        box-shadow: 0 0.1rem 0.03rem -0.06rem #dfdfdf, 0 0.06rem 0.06rem 0 #dfdfdf, 0 0.03rem 0.16rem 0 #dfdfdf;
        font-size: 0.8rem;
    }

    .dept {
        padding-left: 10px;
    }
</style>